// src/components/TrafficChart.jsx
import React from 'react';
import '../styles/PartnerAnalyticsDemo.css';

const TrafficChart = ({ data }) => {
  const maxValue = Math.max(...Object.values(data));

  return (
    <div className="traffic-chart">
      <div className="bar-container">
        {Object.entries(data).map(([day, value]) => {
          const height = (value / maxValue) * 180;
          const isWeekend = day === 'Saturday' || day === 'Sunday';
          
          return (
            <React.Fragment key={day}>
              <div 
                className={`bar ${isWeekend ? 'weekend' : ''}`} 
                style={{ height: `${height}px` }}
              >
                <div className="bar-value">{value}</div>
              </div>
              <div className="bar-label">{day.substring(0, 3)}</div>
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default TrafficChart;